/* eslint-disable */
import router from "@/router";
import axios, { AxiosInstance } from "axios";

const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL as string, 
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const externalApi: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_RECETA_ELECTRONICA as string, 
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(config => {
  const excludedRoute = "Auth/Login";

  if(config.url && !config.url.includes(excludedRoute)){
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } else if(config.url){
    if(config.data){
      config.data = sanitizeData(config.data);
    }
  }
  config.headers['Content-Type'] = 'application/json';
  return config;
}, error => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      router.push('/auth/login');
    }
    if (error.response && error.response.status === 503) {
      router.push('/error');
    }
    return Promise.reject(error);
  }
);

function sanitizeData(data: { [x: string]: string; }) {
  if (typeof data === 'object') {
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string') {
        data[key] = data[key]
          .replace(/['";\-]{2,}/g, '')
          .replace(/\b(SELECT|INSERT|DELETE|DROP|UPDATE|WHERE|FROM|TABLE)\b/gi, '');
      }
    });
  }
  return data;
}

export { apiClient, externalApi };
